import React from "react";
import Button from "@mui/joy/Button";
import Backdrop from "@mui/material/Backdrop";
import TextField from "@mui/material/TextField";
import ToastMessage from "../../../common/ToastMessage";
import InputAdornment from "@mui/material/InputAdornment";
import useScreenWidth from "../../../store/useScreenWidth";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { styled } from "@mui/system";
import { Modal } from "@mui/base/Modal";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { darkModeBackgroud } from "../../../utils/constants";
import { useDarkModeStore } from "../../../store/useDarkModeStore";
import { useLanguageStore } from "../../../store/useLanguageStore";
import { ModalContent } from "../../../common/TopBar/Buttons/SearchTopBarModal";

export const StyledBackdrop = styled(Backdrop)(() => ({
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 1200,
  pointerEvents: "none",
}));

interface NewAccModalProps {
  email: string;
  open: boolean;
  route: string;
  password: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NewAccModal: React.FC<NewAccModalProps> = ({ email, password, open, route, setOpen }) => {
  const navigate = useNavigate();
  const isSmallScreen = useScreenWidth();

  const { language } = useLanguageStore();
  const { darkMode } = useDarkModeStore();

  const handleClick = () => {
    setOpen(false);
    navigate(route);
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)} slots={{ backdrop: StyledBackdrop }}>
      <ModalContent
        sx={{
          zIndex: 1300,
          top: "50%",
          left: "50%",
          minHeight: "350px",
          maxHeight: "350px",
          position: "fixed",
          width: isSmallScreen ? 300 : 400,
          transform: "translate(-50%, -50%)",
          backgroundColor: darkMode ? darkModeBackgroud : "white",
        }}
      >
        <div className="d-flex flex-column pt-3 pb-3">
          <h2 className="ms-3 mb-0" style={{ color: darkMode ? "white" : "#32475C99" }}>
            {route === "/manageusers" ? language["ChangedPassword"] : language["NewUser"]}
          </h2>
          <hr style={darkMode ? { borderColor: "white", opacity: 1 } : {}} />
          <div className="d-flex flex-column p-4 gap-3">
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              value={email}
              InputProps={{
                readOnly: true,
                style: {
                  color: darkMode ? "white" : "black",
                },
              }}
              InputLabelProps={{
                style: {
                  color: darkMode ? "white" : "",
                },
              }}
            />
            <CopyToClipboard text={password} onCopy={() => ToastMessage.Info("Text copied to clipboard!")}>
              <TextField
                id="show-password-user"
                role="button"
                label="Password"
                variant="outlined"
                className="cursor-pointer alert—check"
                value={password}
                InputProps={{
                  readOnly: true,
                  style: {
                    color: darkMode ? "white" : "black",
                  },
                  endAdornment: (
                    <InputAdornment position="end" style={{ cursor: "pointer", color: darkMode ? "white" : "black" }}>
                      <ContentCopyIcon />
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  sx: {
                    color: darkMode ? "white" : "",
                    "&:hover": {
                      backgroundColor: "#CFF4FC",
                      borderRadius: "5px",
                    },
                  },
                }}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#CFF4FC",
                    borderRadius: "5px",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: darkMode ? "white" : "black",
                    },
                    "&:hover fieldset": {
                      borderColor: "#CFF4FC",
                      borderRadius: "5px",
                    },
                  },
                  "& .MuiInputBase-input": {
                    color: darkMode ? "white" : "black",
                  },
                  "&:hover .MuiInputBase-input": {
                    color: "#0575B1",
                  },
                  "& .MuiInputLabel-root": {
                    color: darkMode ? "white" : "",
                  },
                  "&:hover .MuiInputLabel-root": {
                    color: "#0575B1",
                  },
                  "& .password-icon": {
                    color: darkMode ? "white" : "black",
                  },
                  "&:hover .password-icon": {
                    color: "#0575B1",
                  },
                }}
              />
            </CopyToClipboard>
          </div>
          <hr style={darkMode ? { borderColor: "white", opacity: 1 } : {}} />
          <div className="d-flex ms-auto me-2" style={{ marginTop: 10 }}>
            <Button
              sx={{
                color: "white",
                width: "150px",
                fontSize: "16px",
                background: "rgb(133, 146, 163)",
                "&:hover": {
                  background: "#D1D5DB",
                },
              }}
              onClick={handleClick}
            >
              {language["End"]}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};
export default NewAccModal;
